const SNAKE_CASE_TO_DISPLAY: Record<string, string> = {
  first_name: 'First Name',
  last_name: 'Last Name',
  email: 'Professional Email',
  personal_email: 'Personal Email',
  phone_number: 'Phone Number',
  current_title: 'Current Title',
  current_company: 'Current Company',
  start_date: 'Start Date',
  end_date: 'End Date',
  gender: 'Gender',
  ethnicity: 'Ethnicity',
  highest_degree: 'Highest Degree',
  salary_base: 'Base Salary',
  salary_total: 'Total Compensation',
  user_location: 'Location',
  location: 'Location',
  prestige: 'Prestige',
  education: 'School',
  remote_suitability: 'Remote Suitability',
  years_of_experience: 'Years of Experience',
  flight_risk: 'Flight Risk',
  employment_relationship: 'Employment Type',
  work_schedule: 'Work Schedule',
  linkedin_url: 'Profile URL',
  graduation_year: 'Graduation Year',
  work_history: 'Work History',
  education_history: 'Education History',

  // Posting Discovery columns
  company_name: 'Company',
  jobtitle: 'Job Title',
  description: 'Description',
  salary: 'Salary',
  seniority: 'Seniority',
  skills: 'Skills',
  remote_type: 'Remote Type',
  region: 'Region',
  country: 'Country',
  state: 'State',
  msa: 'Metro Area',
  city: 'City',
  rics_k10: 'RICS K10',
  rics_k50: 'RICS K50',
  rics_k400: 'RICS K400',
  post_date: 'Post Date',
  posting_url: 'Posting URL',
  expected_hires: 'Expected Hires',
};

const invertObject = (obj: Record<string, string>): Record<string, string> => {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      acc[value] = key;
      return acc;
    },
    {} as Record<string, string>
  );
};

const DISPLAY_TO_SNAKE_CASE: Record<string, string> = invertObject(
  SNAKE_CASE_TO_DISPLAY
);

export const toDisplayName = (snakeCase: string): string => {
  return SNAKE_CASE_TO_DISPLAY[snakeCase] ?? snakeCase;
};

const toSnakeCase = (displayName: string): string => {
  return DISPLAY_TO_SNAKE_CASE[displayName] ?? displayName;
};

export const migrateColumnNames = (columns: string[]): string[] => {
  return columns.map((col) => toSnakeCase(col));
};
